import { render, staticRenderFns } from "./GardenPlantTabs.vue?vue&type=template&id=88e9194e"
import script from "./GardenPlantTabs.vue?vue&type=script&lang=ts"
export * from "./GardenPlantTabs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports